import { useQuery } from '@tanstack/react-query';

import { Apuracao } from '../types';

import { useListagemContext } from 'context/ListagemContext';
import { RequestListagem, RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';

export function useQueryApuracoes() {
    const requestListagem = useRequestListagem();
    const { filter, autoLoad, sort, page, limit } = useListagemContext();

    const requestOptions: RequestOptionsType = {
        url: '/financeiro/apuracao',
        sort: sort.length ? sort : [{ property: 'idApuracao', direction: 'DESC' }],
        filter: [{ property: 'fgAtivo', operator: 'eq', value: true }, ...filter],
        nested: true,
        page,
        limit,
    };

    return useQuery<RequestListagem<Apuracao[]>>(['queryApuracoes', requestOptions], () => requestListagem(requestOptions).then((res) => res.data), {
        enabled: autoLoad,
    });
}
